import { useMemo } from 'react'
import CircleSpinner from '@components/shared/CircleSpinner'
import ProgressBar from '@components/shared/ProgressBar'

const ExportRunsheetDialogExportingView = ({
    progressMax,
    progressValue,
}) => {
    
    const percentComplete = useMemo(() => Math.floor(
        Math.min(Math.max(progressValue / progressMax * 100, 0), 100),
    ), [progressMax, progressValue])
    
    return (
        
        <div className="mt-4">
            
            <p className="mr-3">
                Exporting runsheet and selected documents...
                &nbsp;
                {(progressMax > 0 && progressValue > 0) && (
                    <code>{percentComplete}%</code>
                )}
            </p>
            
            <div className="mt-6">
                {(progressMax <= 0 && progressValue <= 0) ? (
                    <CircleSpinner className="" />
                ) : (
                    <ProgressBar
                        className=""
                        barClassName=""
                        max={progressMax}
                        value={progressValue} />
                )}
            </div>
        
        </div>
        
    )
    
}

export default ExportRunsheetDialogExportingView
